<script setup lang="ts">
import { computed } from 'vue';

import IconCheck from '@/shared/components/UI/Icons/IconCheck.vue';

type Props = {
  position: 'middle' | 'right';
  achieved: boolean;
};

const props = defineProps<Props>();

const style = computed(() => {
  if (props.position === 'right') {
    return 'left: 99.5%; transform: translate(-99.5%, -50%);';
  }
  return 'left: 50%; transform: translate(-50%, -50%);';
});
</script>

<template>
  <div
    :class="[
      'absolute flex size-4.5 items-center justify-center rounded-full',
      achieved ? 'bg-primary' : 'bg-primary-200'
    ]"
    :style="`${style} top: 50%;`"
  >
    <IconCheck v-if="achieved" class="size-3 text-white" />
  </div>
</template>
